import React from 'react';
import './GuideDownload.css';

const GuideDownload = () => {
  const handleDownload = () => {
    // Logique de téléchargement à implémenter
    alert('Le téléchargement du guide va commencer...');
  };

  return (
    <section className="guide-section">
      <div className="guide-container">
        <h2 className="guide-title">
          TÉLÉCHARGEZ NOTRE GUIDE
        </h2>
        
        <h3 className="guide-subtitle">
          "LES 7 PILIERS DE LA PROSPECTION B2B EFFICACE"
        </h3>
        
        <p className="guide-description">
          Une infographie exclusive et un livre blanc complet pour comprendre 
          les fondamentaux de la nouvelle prospection B2B à l'ère de l'IA.
        </p>
        
        <button className="guide-button" onClick={handleDownload}>
          RECEVOIR LE GUIDE
        </button>
      </div>
    </section>
  );
};

export default GuideDownload; 